import { createServerFn } from '@tanstack/react-start';
import { getAppSession } from './session';
import { refreshAuthIfExpired } from './refreshAuth';

export const getAuth = createServerFn({ method: 'GET' }).handler(async () => {
    await refreshAuthIfExpired();
    const session = await getAppSession();
    if (session?.data) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { refresh_token, refresh_expires, ...data_without_refresh } =
            session.data;
        return data_without_refresh?.access_token ? data_without_refresh : null; // Destructure and exclude refresh token info for client side
    }
    return null;
});
